import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

/*经验分享：如果微信开发工具没有启用gpu加速，会导致某些画面变灰*/
new Vue({
    render: h => h(App),
}).$mount('#app')
